import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import BlogTagsTable from "../../components/blog-tags/BlogTagsTable";

const BlogTagsList = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <BlogTagsTable />
        </WrapperSection>
    );
};

export default BlogTagsList;
